import React from "react";

import LookExitButton from "./lookNavigation/lookExitButton";
import LookRoomIdeasButton from "./lookNavigation/lookRoomIdeasButton";
import LookCartButton from "./lookNavigation/lookCartButton";
import {connect} from "react-redux";
import {ROUTES} from "../../routes";
import {LOOK_INTRO_STEPS, LOOK_INTRO_STEPS_MOBILE} from "./core/constants";


const LookFixedButtons = (props) => {

  const {lookPageOpened, isMobile, introStep} = props;

  const isActive = lookPageOpened === ROUTES.rooms;
  const popperStep = isMobile ? LOOK_INTRO_STEPS_MOBILE.rooms : LOOK_INTRO_STEPS.layoutsAndRooms;

  return (
    <div className={"look-mobile-buttons" + ((isActive || (introStep === popperStep)) ? " look-room-button--on-top" : "")}>
      <LookExitButton/>
      <LookRoomIdeasButton/>
      <LookCartButton/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened, introStep} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    isMobile,
    lookPageOpened,
    introStep,
  };
};

export default connect(mapStateToProps)(LookFixedButtons)
